import { Link, useLocation } from 'react-router-dom'
import { getLangFromPathname, localizePath } from '@/utils/localeFromUrl'
import type { ComponentProps } from 'react'

type LinkProps = ComponentProps<typeof Link>

/**
 * Link that prefixes the path with current language from URL (/ar, /en, ...).
 * Use for internal app routes. External URLs (http/https) are passed through unchanged.
 */
export default function LocalizedLink({ to, ...rest }: LinkProps) {
  const { pathname } = useLocation()
  const lang = getLangFromPathname(pathname)

  const resolvedTo: LinkProps['to'] =
    typeof to === 'string' && to.startsWith('/') && !to.startsWith('//') && !/^https?:\/\//i.test(to)
      ? localizePath(lang, to)
      : to

  return <Link to={resolvedTo} {...rest} />
}
